import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_ADMIN_API_URL || 'https://ampsweb.saassrs.com/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const contactAPI = {
  getAll: (params) => api.get('/contacts', { params }),
  getById: (id) => api.get(`/contacts/${id}`),
};

export const contactFormAPI = {
  submit: (data) => api.post('/contact-form', data),
};

export const insightAPI = {
  getAll: (params) => api.get('/insights', { params }),
  getById: (id) => api.get(`/insights/${id}`),
};

export const blogAPI = {
  getAll: (params) => api.get('/blogs', { params }),
  getById: (id) => api.get(`/blogs/${id}`),
  getByTitle: (title) => api.get(`/blogs/${encodeURIComponent(title)}`),
  getBySlug: (slug) => api.get(`/blogs/${slug}`),
  create: (formData) => {
    const blogApi = axios.create({
      baseURL: API_BASE_URL,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return blogApi.post('/blogs', formData);
  },
  update: (id, formData) => {
    const blogApi = axios.create({
      baseURL: API_BASE_URL,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return blogApi.put(`/blogs/${id}`, formData);
  },
  delete: (id) => api.delete(`/blogs/${id}`),
};

export default api;

